import { Order } from '../types/types';

const alphanumericComparator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

const alphanumericColumns = new Set(['port']);
const dateColumns = new Set(['created_at', 'last_seen']);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (alphanumericColumns.has(orderBy as string)) {
    const aValue = String(a[orderBy]).toLowerCase();
    const bValue = String(b[orderBy]).toLowerCase();

    let sortOrder = -alphanumericComparator.compare(aValue, bValue);

    if (aValue.startsWith('te') && bValue.startsWith('tw')) {
      sortOrder = -1;
    }

    return sortOrder;
  }

  if (dateColumns.has(orderBy as string)) {
    const dateA = new Date(a[orderBy] as string);
    const dateB = new Date(b[orderBy] as string);

    if (dateB < dateA) {
      return -1;
    }
    if (dateB > dateA) {
      return 1;
    }
    return 0;
  }

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
  ignoreColumns: string[] = []
): (
  a: { [key in Key]: number | string | boolean },
  b: { [key in Key]: number | string | boolean }
) => number {
  if (ignoreColumns.includes(orderBy as string)) {
    return () => 0;
  }

  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
